export default __webpack_public_path__ + "static/Mutagel-b66b0f7098f7a8f1ce3e6598245a62b7.png";